export class Location {
  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly address: string,
    public readonly city: string,
    public readonly zipcode: string,
    public readonly monitored: boolean,
    public readonly organizationId: string,
    public readonly sensorIds: string[] = [],
    public readonly createdAt: Date = new Date(),
    public readonly updatedAt: Date = new Date()
  ) {}

  static create(
    id: string,
    name: string,
    address: string,
    city: string,
    zipcode: string,
    organizationId: string,
    monitored: boolean = true
  ): Location {
    return new Location(
      id,
      name,
      address,
      city,
      zipcode,
      monitored,
      organizationId
    );
  }

  hasSensors(): boolean {
    return this.sensorIds.length > 0;
  }

  getSensorCount(): number {
    return this.sensorIds.length;
  }

  updateAddress(address: string, city: string, zipcode: string): Location {
    return new Location(
      this.id,
      this.name,
      address,
      city,
      zipcode,
      this.monitored,
      this.organizationId,
      this.sensorIds,
      this.createdAt,
      new Date()
    );
  }

  toggleMonitoring(): Location {
    return new Location(
      this.id,
      this.name,
      this.address,
      this.city,
      this.zipcode,
      !this.monitored,
      this.organizationId,
      this.sensorIds,
      this.createdAt,
      new Date()
    );
  }

  getFullAddress(): string {
    return `${this.address}, ${this.city} ${this.zipcode}`;
  }
}